// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___CSpS","colBig":"styles_colBig__20mQH","colSmall":"styles_colSmall__1YVvw"};